import ProductLabCategories from './ProductLabCategories'

export default ProductLabCategories
